<template>
  <div class="coupon mt-10">
    <div :class="item.status.key == 'unused' ? 'img' : 'img1'"></div>
    <div class="left">
      <p class="price">
        {{ item.coupon.amount == 0 ? "5折券" : "￥" + item.coupon.amount }}
        <span class="price_source">{{ item.coupon.source }}</span>
      </p>
      <p class="type gray">
        满{{
          item.coupon.usage_condition == 0
            ? "任意金额"
            : item.coupon.usage_condition + "元"
        }}可用
      </p>
      <p class="time gray">有效期至{{ item.invalid_time.split("T")[0] }}</p>
    </div>
    <div class="right">
      <van-button
        type="default"
        class="btn flag1 f12"
        v-if="item.status.key == 'unused'"
        @click="goClass()"
        >立即使用</van-button
      >
      <van-button
        type="default"
        class="btn flag2 f12"
        v-if="item.status.key == 'used'"
        >已使用</van-button
      >
      <van-button
        type="default"
        class="btn flag3 f12"
        v-if="item.status.key == 'invalid'"
        >已失效</van-button
      >
    </div>
  </div>
</template>

<script>
import store from "../store/index";
export default {
  name: "couponCard",
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  methods: {
    goClass() {
      let coupon = {
        id: this.item.id,
        amount: this.item.coupon.amount,
        condition: this.item.coupon.usage_condition,
      };
      store.commit("set_coupon", coupon);
      this.$router.push("./../class");
    },
  },
};
</script>

<style lang="less" scoped>
.coupon {
  width: 100%;
  height: 100px;

  .img {
    background: url("../assets/img/my/couponbg.png") no-repeat center center;
    width: 100%;
    height: 100%;
    background-size: 90% 100%;
  }
  .img1 {
    background: url("../assets/img/my/couponbg1.png") no-repeat center center;
    width: 100%;
    height: 100%;
    background-size: 90% 100%;
  }

  // border: solid;
  // border-radius: 15px;
  // border-width: 1px;
  // color: gray;

  .left {
    width: 50%;
    float: left;
    margin-top: -80px;
    margin-left: 10%;

    .price {
      font-size: 20px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #ffffff;
      line-height: 17px;
      letter-spacing: 1px;
    }

    .type {
      font-size: 10px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      line-height: 15px;
      margin-top: 4px;
      font-size: small;
    }

    .time {
      margin-top: 14px;
      font-size: small;
      font-size: 10px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      line-height: 17px;
    }
  }

  .right {
    // width: 35%;
    float: right;
    margin-top: -80px;
    margin-right: 10%;

    .btn {
      border-radius: 8px;
      height: 20px;
      line-height: 20px;
      margin-top: 15px;
    }

    .flag1 {
      background: #f5a623;
      color: white;
      font-size: 13px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
      line-height: 17px;
      letter-spacing: 1px;
    }

    .flag2 {
      background: #f2f2f3;
      color: #42686e;
      font-size: 13px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      line-height: 17px;
      letter-spacing: 1px;
    }

    .flag3 {
      background: #f2f2f3;
      color: #4a4a4a;
      font-size: 13px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      line-height: 17px;
      letter-spacing: 1px;
    }
  }
}

.gray {
  color: #9b9b9b;
  font-size: 10px;
}

.line {
  height: 80px;
  margin-left: 10%;
  float: left;
  width: 1px;
  background: black;
  border-left-style: solid;
  border-bottom-style: none;
  border-right-style: none;
  border-top-style: none;
}

.price_source {
  font-size: 12px;
}
</style>
